const state = () => ({
    payment_types: [],
    payments: [],
    bank_codes: [],
    description: '',
    client: {},
    loading: false,
    includesVAT: true,
    comments: {},
    invoiceAndReceipt: true,
})

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
